import {
  LOGIN_FORM_CHANGED,
  IS_LOADING,
  LOG_OUT,
  ROLES,
  AUTHENTICATE_THE_USER_FALSE,
} from "./accountActionsTypes";
import { HUB_CONNECTION } from "../../realtime/hubActionTypes";
import { WebStorageNames } from "../../../utils";

const INITIAL_STATE = {
  isLoading: false,
  isLoggedIn: false,
  hubConnection: null,
  roles: [],
  isAnnualLeavePopupShown: false,
  isAuthenticate: false,
  isValidatingToken: false,
  isTokenPresent: Boolean(localStorage.getItem(WebStorageNames.AuthInfo)),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_FORM_CHANGED:
      return {
        ...state,
        [action.payload.prop]: action.payload.value,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case LOG_OUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    case ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case "SET_ANNUAL_LEAVE_POPUP_SHOWN":
      return {
        ...state,
        isAnnualLeavePopupShown: action.payload,
      };
    case HUB_CONNECTION.STATE.CREATED:
      return { ...state, hubConnection: action.payload };
    case HUB_CONNECTION.STATE.CLOSED:
      if (state.hubConnection)
        state.hubConnection.stop();
      return { ...state, hubConnection: null };
    case AUTHENTICATE_THE_USER_FALSE:
      if (state.hubConnection)
        state.hubConnection.stop();
      return {
        ...state,
        isAuthenticate: false,
        isValidatingToken: false,
        hubConnection: null
      };
    default:
      return state;
  }
};
